import styled from "styled-components"

const ProgressStatus = styled.div`
  text-transform: uppercase;
  width: 100%;
  position: absolute;
  top: 54px;
  text-align: center;
  font-size: ${props => props.theme.font.size.subheadline};
  transition: ${props => props.theme.transition.long};
`

export default ProgressStatus
